export default __webpack_public_path__ + "static/media/ovo_xl.2c3615d9.jpg";